import { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Hero from "./components/Home/Hero";
import Metrics from "./components/Home/Metrics";
import Services from "./components/Home/Services";
import Contact from "./components/Home/Contact";
import Value from "./components/Home/Value";
import CasosExito from "./components/Home/CasosExito";
import FAQ from "./components/Home/FAQ";
import CTA from "./components/Home/CTA";
import Footer from "./components/Footer";
import Nosotros from "./pages/Nosotros";
import ServiciosPage from "./pages/ServiciosPage";
import ContactoPage from "./pages/Contacto";

function App() {
  const [message, setMessage] = useState("");

  /*useEffect(() => {
    fetch("http://127.0.0.1:8000/")
      .then((res) => res.json())
      .then((data) => setMessage(data.message));
  }, []);*/

  // Home page component
  const HomePage = () => (
    <>
      <Hero />
      <Metrics />
      <Services />
      <Contact />
      <Value />
      
      <FAQ />
      <CTA />
    </>
  );
  // luego <CasosExito />

  return (
    <Router>
      <div className="min-h-screen bg-white">
        <Navbar />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/nosotros" element={<Nosotros />} />
          <Route path="/servicios" element={<ServiciosPage />} />
          <Route path="/contacto" element={<ContactoPage />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;